<template>
  <img
    :style="angle"
    src="~@/assets/images/compass.svg"
    class="compass"
    width="88px"
  >
</template>

<script>
export default {
  computed: {
    currentBuildingId: ({ $store }) => $store.state.current.buildingId,
    currentBuilding: ({ $store, currentBuildingId }) => $store.getters['area/buildingFind'](currentBuildingId),
    angle: ({ currentBuilding }) => ({ transform: `rotateZ(${currentBuilding.angle}deg)` }),
  },
};
</script>

<style scoped lang="scss">
.compass {
  margin-top: 13px;
}
</style>



// WEBPACK FOOTER //
// building_compass.vue?627b1d59